import { SupportedPlatforms } from '@smg-real-estate/domus';
import { type VueHeadClient } from '@unhead/vue/client';
import { type App, type Component } from 'vue';
import { type Router } from 'vue-router';

import { initI18n } from '@/i18n-setup';
import { AppState } from '@/store/types';
import { Store } from 'vuex';
import { createVueApp } from './createApp';

export async function createAppByPlatform(appComponent: Component): Promise<{
  app: App<Element>;
  router: Router;
  store: Store<AppState>;
  head: VueHeadClient;
}> {
  const defaultTranslations = await import('@/i18n/de-hg');

  const i18n = initI18n(defaultTranslations.default);

  return createVueApp(appComponent, i18n, SupportedPlatforms.hg);
}
